import React from 'react';
const UpdateStatus = (props) => {
    return (
        <>
            
        </>
     );
}
 
export default UpdateStatus;